import { Moon, Heartbeat, Barbell, PersonSimpleRun, ForkKnife, Brain, PersonSimpleTaiChi, WaveTriangle, TrendUp } from "@phosphor-icons/react";

export const PILLAR_META = {
  sleep: { label: "Sleep", icon: Moon, color: "#8B7CF6", desc: "How well and how long you slept" },
  recovery: { label: "Recovery", icon: Heartbeat, color: "#16BC9C", desc: "How ready your body is for effort today" },
  cardio: { label: "Cardio", icon: PersonSimpleRun, color: "#EF6A56", desc: "Your heart & lung fitness from daily movement" },
  strength: { label: "Strength", icon: Barbell, color: "#B5543A", desc: "Muscle you're building and keeping" },
  mobility: { label: "Mobility", icon: PersonSimpleTaiChi, color: "#8A9A7B", desc: "How freely your joints move" },
  nutrition: { label: "Nutrition", icon: ForkKnife, color: "#E8A54B", desc: "How well your food fuels you" },
  stress: { label: "Stress", icon: WaveTriangle, color: "#9C7B9C", desc: "How under-control your stress load is" },
  mental: { label: "Mind", icon: Brain, color: "#E2C275", desc: "Your mood, energy and motivation" },
  consistency: { label: "Consistency", icon: TrendUp, color: "#16BC9C", desc: "How regularly you show up" },
};

export const scoreBand = (s) => {
  if (s >= 850) return { label: "Elite", color: "#16BC9C" };
  if (s >= 700) return { label: "Thriving", color: "#16BC9C" };
  if (s >= 550) return { label: "Building", color: "#EF6A56" };
  if (s >= 400) return { label: "Rebuilding", color: "#E8A54B" };
  return { label: "Foundations", color: "#B5543A" };
};
